<ng-container>
  <div class="modal-add-info mb-30">
    @if (isVerificationPending()) {
      <h3 class="modal-add-info-headline pt-20">{{ "modal_verification_progress_title" | translate }}</h3>
      <p class="modal-add-info-text text-narrow center-block">
        {{ "modal_verification_progress_info" | translate }}
      </p>
    } @else {
      <h3 class="modal-add-info-headline">
        {{ "because_of_verification_you_cant_use_deposit_header" | translate }}
      </h3>
      <p class="modal-add-info-text text-narrowest center-block">
        {{ "trade_decision_aml_regulation" | translate }}
      </p>
      <button
        class="modal-add-info-button btn btn-primary btn-inverse btn-bold btn-bigger-text"
        (click)="verify()"
        type="button">
        <i class="bpi__icon-verify"></i>
        {{ "start_verification_here_button" | translate }}
      </button>
    }
  </div>
</ng-container>
